<template>
  <div
    id="price-module"
    class="price-module"
    @click="handleClickTrack"
    :class="[discountType, type, { normal: isNormalTheme, 'no-publish': salePrice === 999999 }]" aria-live="polite"
    tabindex="0"
  >
    <!-- 到手价 -->
    <div
      class="estimated-price"
      :class="{ gold: priceLabelType === 3, silver: priceLabelType === 4, diamond: priceLabelType === 5 }"
      @click="showDiscountPopup"
      :style="{ color: type === 'popup' ? '' : imgColor }"
      v-if="isShowEstimatedPrice"
    >
      <!-- todo 缺少学生专享-->
      <div class="des" v-if="priceLabelType === 0 && estimatedPrice != salePrice" aria-label="到手预估">
        到手
        <br />
        预估
      </div>
      <div class="des" v-else-if="priceLabelType === 2" aria-label="新人专享">
        新人
        <br />
        专享
      </div>
      <div class="des" v-else-if="priceLabelType === 1" aria-label="学生专享">
        学生
        <br />
        专享
      </div>
      <img
        v-else-if="priceMemberIconAndLabel"
        :src="priceMemberIconAndLabel.iconImg"
        :alt="priceMemberIconAndLabel.alt"
        class="member-logo"
      />
      <div class="price" :aria-label="estimatedPrice + '元'">
        <div class="symbol" aria-hidden="true">￥</div>
        <div class="number" aria-hidden="true">{{ isBlur ? '----' : estimatedPrice }}</div>
      </div>
    </div>
    <!-- 活动价也就是售卖价 -->
    <div class="normal-price" v-else>
      <template v-if="salePrice === 999999">
        <div class="symbol" aria-hidden="true">￥</div>
        <div class="text">待发布</div>
      </template>
      <template v-else-if="isGift && salePrice === 0">
        <!-- <div class="symbol">￥</div> -->
        <div class="number">暂无报价</div>
      </template>
      <template v-else>
        <div class="symbol" aria-hidden="true">￥</div>
        <div class="number" :aria-label="salePrice + '元'">{{ salePrice }}</div>
      </template>
    </div>
    <!-- 划线价，赠品不显示划线价 -->
    <div class="del-price" :class="{ through: !isShowEstimatedPrice }" v-if="delPrice > showPrice && !isGift">
      <div class="symbol">￥</div>
      <div class="number" :aria-label="`原价${delPrice}元`">{{ delPrice }}</div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { formatNumber } from 'utils/common'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('detailv3')
export default {
  name: 'EstimatedPrice',
  props: {
    // 是否是popup
    type: String,
    params: Object // params.isSpot是否定金预售的现货购买
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'commodityEstimated',
      'skuId',
      'discountType',
      'currentSuiteInfo',
      'isGift',
      'isSpot',
      'customAtmosphereInfo',
      'hasCustomAtmosphereBg',
      'totalAdditionCommodityActivityPrice', //加购商品售价
      'totalAdditionCommoditySalePrice' //加购商品市场价
    ]),
    ...mapState(['skuInfo', 'spotEstimatedPrice', 'isRegulate']),
    // 到手价类型 黄金、白银、普通、新人专享、学生专享
    // 价格标签类型 0：到手预估 1：学生价 2：新人价 3：黄金会员价 4：白银会员价
    priceLabelType() {
      let priceLabelType = this.commodityEstimated?.priceLabelType
      if (this.type === 'popup' && this.spotEstimatedPrice) {
        priceLabelType = this.spotEstimatedPrice.priceLabelType
      }
      return priceLabelType || 0
    },
    priceMemberIconAndLabel() {
      if (this.priceLabelType == 3) {
        return {
          alt: '黄金专享',
          iconImg: this.commodityEstimated?.levelIconUrl // 服务端返回字段
        }
      }
      if (this.priceLabelType == 4) {
        return {
          alt: '白银专享',
          iconImg: this.commodityEstimated?.levelIconUrl
        }
      }
      if (this.priceLabelType == 5) {
        return {
          alt: '钻石专享',
          iconImg: this.commodityEstimated?.levelIconUrl
        }
      }
      return null
    },
    isBlur() {
      return !this.isRegulate
    },
    isNormalTheme() {
      return this.type === 'popup'
    },
    imgColor() {
      if (
        this.hasCustomAtmosphereBg &&
        this.customAtmosphereInfo?.priceColor &&
        this.priceLabelType !== 3 &&
        this.priceLabelType !== 4 &&
        this.priceLabelType !== 5
      ) {
        return this.customAtmosphereInfo?.priceColor
      }
      return this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityBigPromotion?.imgColor
    },
    isSuite() {
      return this.currentSuiteInfo.id
    },
    isShowEstimatedPrice() {
      if (this.isSuite) {
        return false
      } else if (this.isDeposit) {
        if (this.type === 'popup') {
          return this.spotEstimatedPrice
        } else {
          return this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.depositSwellAmount
        }
      } else {
        return this.estimatedPrice
      }
    },
    isDeposit() {
      return this.discountType === 'deposit'
    },
    estimatedPrice() {
      if (this.isDeposit) {
        if (this.type === 'popup') {
          return formatNumber(
            this.spotEstimatedPrice?.commodityEstimatedPrice + this.totalAdditionCommodityActivityPrice
          )
        }
      }
      return formatNumber(
        this.commodityEstimated?.commodityEstimatedPrice +
          (this.type == 'popup' ? this.totalAdditionCommodityActivityPrice : 0)
      )
    },
    salePrice() {
      let price = 0
      if (this.isSuite) {
        price = this.currentSuiteInfo.totalPrice
      } else if (this.isDeposit) {
        price = this.skuInfo.commoditySkuBaseInfo.salePrice
      } else {
        price = this.skuInfo.commoditySkuDiscount.commodityDiscountPrice || this.skuInfo.commoditySkuBaseInfo.salePrice
      }
      return formatNumber(price + (this.type == 'popup' ? this.totalAdditionCommodityActivityPrice : 0))
    },
    marketPrice() {
      return this.skuInfo.commoditySkuBaseInfo.marketPrice
    },
    // 展示的销售价格
    showPrice() {
      if (this.isSuite) {
        return formatNumber(
          this.currentSuiteInfo.totalPrice + (this.type == 'popup' ? this.totalAdditionCommodityActivityPrice : 0)
        )
      } else {
        return this.estimatedPrice ? this.estimatedPrice : this.salePrice
      }
    },
    delPrice() {
      let price = 0
      if (this.isSuite) {
        price = this.currentSuiteInfo.totalPrice + this.currentSuiteInfo.discountAmount
      } else if (this.isDeposit) {
        price = this.skuInfo.commoditySkuBaseInfo.salePrice
      } else {
        if (this.estimatedPrice) {
          if (this.estimatedPrice < this.salePrice) {
            price = this.salePrice
          } else {
            price = this.marketPrice
          }
        } else {
          price = this.marketPrice
        }
      }
      return formatNumber(price + (this.type == 'popup' ? this.totalAdditionCommoditySalePrice : 0))
    }
  },
  methods: {
    ...mapActions(['changeDiscountPopupStatus']),
    handleClickTrack() {
      if (this.priceLabelType === 2) {
        this.$track({
          event_id: '081|065|01|077',
          cfrom: '081|065|01|077',
          sku_id: this.skuId
        })
      }
    },
    showDiscountPopup() {
      // 现货到手价不展示优惠明细
      if (this.isSpot && this.params?.isSpot) {
        return
      }
      this.changeDiscountPopupStatus(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.price-module {
  &.no-publish {
    height: 51px;
    padding-top: 6px;
    margin-bottom: -12px;

    .text {
      margin-top: -42px;
      @include os-font-weight(36, 50);
      -webkit-text-stroke-color: #f10313;
    }
  }

  display: flex;
  align-items: center;

  &.popup {
    height: 96px;

    .estimated-price {
      height: 96px;
    }
  }

  &.quickbuy,
  &.bigpromotion,
  &.quickbuycustomatmos,
  &.group {
    margin-top: 6px;

    .normal-price {
      @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
    }

    .estimated-price {
      background: rgba(255, 255, 255, 0.9);
      color: #ff4811;
    }

    .del-price {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  &.vip {
    .normal-price {
      color: #ffc121;
    }

    .estimated-price {
      background: #ffc121;
      color: #000;
      border: 1px solid #ffc121;
    }

    .del-price {
      color: #876615;
    }
  }

  &.deposit,
  &.fullpay {
    .normal-price {
      @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
    }

    .estimated-price {
      background: rgba(255, 255, 255, 0.9);
      color: #6930f8;
    }

    .del-price {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  &.normal,
  &.isSpot {
    .normal-price {
      color: #f10313;
    }

    .estimated-price {
      background: linear-gradient(93.98deg, #ff6e4e 8.67%, #ff4b40 53.56%, #ff275b 94.85%);
      @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
      border: 1px solid #fff;
    }

    .del-price {
      color: #999;
    }
  }

  .des {
    font-size: 27px;
    margin-right: 12px;
    line-height: 33px;
    flex-shrink: 0;
  }

  .estimated-price {
    width: max-content;
    display: flex;
    align-items: center;
    @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
    padding: 15px 33px;
    border-radius: 180px;
    height: 102px;
    background: linear-gradient(93.98deg, #ff6e4e 8.67%, #ff4b40 53.56%, #ff275b 94.85%);
    @include borderColor(1111, 1px, solid, #fff, transparent);
    box-sizing: border-box;

    &.gold {
      color: #804207;
      background: linear-gradient(95.99deg, #ffcd75 12.59%, #ffd68d 48.44%, #ffc961 88.74%);
      border: 0 !important;
    }

    &.silver {
      color: #3f627c;
      background: linear-gradient(95.99deg, #d6e3ec 12.59%, #c6dcea 88.74%);
      border: 0 !important;
    }

    &.diamond {
      color: #7E71BD;
      background: #ECEAF4;
      border: 0 !important;
    }

    .price {
      display: flex;
      align-items: center;
      @include os-font-weight-number(36, 50);

      .symbol {
        font-size: 36px;
        @include os-font-weight(999, 40);
        margin-top: 0.16rem;
      }

      .number {
        font-size: 72px;
        @include os-font-weight-number(72, 60);
        white-space: nowrap;
      }
    }

    .member-logo {
      min-width: 72px;
      margin-right: 10px;
      height: 72px;
    }
  }

  // 正常展示的价格
  .normal-price {
    display: flex;
    align-items: baseline;
    color: #f10313;
    @include os-font-weight-number(36, 50);
    .symbol {
      @include os-font-weight(999, 40);
      font-size: 36px;
    }

    .number {
      font-size: 72px;
      @include os-font-weight-number(72, 60);
    }

    .text {
      font-size: 51px;
      @include os-font-weight-number(51, 50);
    }
  }

  .del-price {
    color: #999999;
    display: flex;
    align-items: center;
    margin-left: 14px;

    .symbol {
      font-size: 36px;
      letter-spacing: -6px;
    }

    .number {
      font-size: 36px;
      white-space: nowrap;
    }

    &.through {
      text-decoration: line-through;

      .number {
        font-size: 36px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.vivo-fontscale-4 {
  .estimated-price .price .number {
    font-size: 54px;
    @include os-font-weight-number(54, 50);
  }

  .del-price .number {
    font-size: 44px;
    @include os-font-weight-number(44, 50);
  }
}

.vivo-fontscale-5 {
  .estimated-price .price .number {
    font-size: 52px;
    @include os-font-weight-number(51, 50);
  }

  .del-price .number {
    font-size: 42px;
    @include os-font-weight-number(42, 50);
  }
}
</style>
